"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _CloseButton = require("./CloseButton");

var _default = _CloseButton.CloseButton;
exports["default"] = _default;